import Slider from './Slider'

export default Slider
// eslint-disable-next-line import/export
export * from './Slider'
